/* LensAdvisor features page — scroll reveal + sticky anchor nav. */
(function () {
  let stickyNavState = null;

  const measureHeader = () => {
    const header = document.querySelector('#header-group');
    const h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--la-site-header-h', h + 'px');
    return h;
  };

  const initStickyNav = () => {
    const nav = document.querySelector('.la-feat-nav');
    if (!nav) return;
    if (stickyNavState && stickyNavState.nav === nav) return;

    // Clean up any prior listener if the nav was replaced by Shopify's section reload
    if (stickyNavState) {
      window.removeEventListener('scroll', stickyNavState.onScroll);
      window.removeEventListener('resize', stickyNavState.onResize);
      if (stickyNavState.placeholder && stickyNavState.placeholder.parentNode) {
        stickyNavState.placeholder.parentNode.removeChild(stickyNavState.placeholder);
      }
    }

    const placeholder = document.createElement('div');
    placeholder.className = 'la-feat-nav-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    nav.parentNode.insertBefore(placeholder, nav);

    let headerHeight = measureHeader();
    let navTop = 0;

    const measure = () => {
      const wasSticky = nav.classList.contains('is-sticky');
      if (wasSticky) nav.classList.remove('is-sticky');
      placeholder.style.display = 'none';
      const rect = nav.getBoundingClientRect();
      navTop = rect.top + window.scrollY;
      const cs = window.getComputedStyle(nav);
      placeholder.style.height = rect.height + 'px';
      placeholder.style.marginTop = cs.marginTop;
      placeholder.style.paddingTop = cs.paddingTop;
      placeholder.style.borderTopWidth = cs.borderTopWidth;
      placeholder.style.borderTopStyle = 'solid';
      placeholder.style.borderTopColor = 'transparent';
      if (wasSticky) {
        nav.classList.add('is-sticky');
        placeholder.style.display = 'block';
      }
    };

    const onScroll = () => {
      const shouldStick = window.scrollY + headerHeight + 1 >= navTop;
      const isSticky = nav.classList.contains('is-sticky');
      if (shouldStick && !isSticky) {
        nav.classList.add('is-sticky');
        placeholder.style.display = 'block';
      } else if (!shouldStick && isSticky) {
        nav.classList.remove('is-sticky');
        placeholder.style.display = 'none';
      }
    };

    const onResize = () => {
      headerHeight = measureHeader();
      measure();
      onScroll();
    };

    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    stickyNavState = { nav, placeholder, onScroll, onResize };
  };

  const initReveal = () => {
    const roots = document.querySelectorAll('.la-feat-page');
    if (!roots.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = [];
    roots.forEach((root) => {
      root.querySelectorAll('.la-feat-head, .la-feat-cat-head, .la-feat-row, .la-feat-close-inner > div').forEach((el) => {
        if (!el.dataset.laReveal) {
          el.dataset.laReveal = '1';
          targets.push(el);
        }
      });
    });
    if (!targets.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.animate(
          [
            { opacity: 0, transform: 'translateY(14px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 600, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'both' }
        );
        io.unobserve(e.target);
      });
    }, { threshold: 0.1 });
    targets.forEach((el) => { el.style.opacity = '0'; io.observe(el); });
  };

  const init = () => {
    initStickyNav();
    initReveal();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
